module.exports = __webpack_public_path__ + "shanz/static/media/karachi-store.866bbcc8.jpg";